import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/tick.svg'

const Svg = (props) => <SvgComponent {...props} />

export const Tick = withSvgProps(Svg)
